import React from 'react';

import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import '../css/prices.css';

import solicitud from '../media/Caratula_DISH_ON_447-2025.pdf';


const Prices = props =>
{


    return (
        <div id='prices' className='container-fluid p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h3>Solicitud</h3>


                {/* <p><a href={contrato233} target='_blank'>Solicitud de servicios y/o Carátula: 233-2020</a></p> */}
                <p><a href={solicitud} target='_blank'>Solicitud de servicios y / o carátula</a></p>

               


               
               
            </TocPage>
        </div>
    );
}

export default Prices;



// WEBPACK FOOTER //
// ./src/components/Solicitudinalambrico.js